namespace Gordic.Adm.WebControls {
    export abstract class GAdmBase {
        detailCnt: JQuery<HTMLElement>;
    }
}